// Footer.js
import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { scroller } from 'react-scroll';
import styles from './Footer.module.css';

import logo from '../assets/logo192.png'; // Adjust the path as needed

const Footer = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const handleSectionClick = (sectionId) => {
    if (location.pathname !== '/') {
      // If not on home page, navigate to home first, then scroll
      navigate('/');
      // Small delay to ensure page loads before scrolling
      setTimeout(() => {
        scroller.scrollTo(sectionId, {
          duration: 500,
          delay: 0,
          smooth: 'easeInOutQuart'
        });
      }, 100);
    } else {
      // If already on home page, just scroll
      scroller.scrollTo(sectionId, {
        duration: 500,
        delay: 0,
        smooth: 'easeInOutQuart'
      });
    }
  };

  return (
    <footer className={styles.footer}>
      <div className={styles.content}>
        {/* Logo Section */}
        <div className={styles.logoSection}>
          <div className={styles.logo}>
            <img src={logo} alt="Logo" className={styles.logoImg} />
            MusicTeachers.ai
          </div>
        </div>

        {/* Quick Links Section */}
        <div className={styles.quickLinks}>
          <h3 className={styles.columnTitle}>Quick Links</h3>
          <div className={styles.linksList}>
            <button onClick={() => handleSectionClick('home')} className={styles.scrollLink}>Home</button>
            <a href="/features">Features</a>
            <a href="/about">About</a>
            <button onClick={() => handleSectionClick('how-it-works')} className={styles.scrollLink}>How it works</button>
            <button onClick={() => handleSectionClick('pricing')} className={styles.scrollLink}>Pricing</button>
          </div>
        </div>

        {/* Contact Section */}
        <div className={styles.contactSection}>
          <h3 className={styles.columnTitle}>Contact Us</h3>
          <div className={styles.contactInfo}>
            <span>Phone:</span> 
            <span>(609) 222-4369</span>
            <span>Email: info@musicteachers.ai</span>
          </div>
        </div>
      </div>

      {/* Bottom Section */}
      <div className={styles.bottomSection}>
        <div className={styles.legalLinks}>
          <a href="/privacy-policy">Privacy Policy</a>
          <a href="/terms-of-service">Terms of Service</a>
        </div>
        <div className={styles.copyright}>
          © {new Date().getFullYear()} MusicTeachers.ai. All Rights Reserved.
        </div>
      </div>
    </footer>
  );
};

export default Footer;